"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationExecutor = void 0;
var inversify_1 = require("inversify");
var types_1 = require("../types");
var notifyEvents_1 = require("../constants/notifyEvents");
var ApplicationExecutor = /** @class */ (function () {
    function ApplicationExecutor() {
        this.ready = false;
        this.enabled = false;
        this.executing = false;
        this.pendingExecutePair = [];
    }
    ApplicationExecutor.prototype.executePair = function (pair) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, pair.fn()];
                    case 1:
                        _a.sent();
                        if (!(pair.finish && typeof pair.finish === "function")) return [3 /*break*/, 3];
                        return [4 /*yield*/, pair.finish()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApplicationExecutor.prototype.executeQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.executing) {
                            return [2 /*return*/];
                        }
                        // 可能产生竞争状态，导致 readyToExecute 内函数被多次执行
                        // 因此使用 executing 标识
                        // 由于 ready 状态时，此次调用会马上执行 callback，因此应不存在 pendingExecutePair 内函数被多次执行的情况
                        this.executing = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(this.pendingExecutePair.map(this.executePair))];
                    case 2:
                        _a.sent();
                        this.executing = false;
                        this.pendingExecutePair = [];
                        this.observableService.notify(notifyEvents_1.NOTIFY_EXECUTE_QUEUE_FINISH);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.executing = false;
                        this.pendingExecutePair = [];
                        this.observableService.notify(notifyEvents_1.NOTIFY_EXECUTE_QUEUE_ERROR);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApplicationExecutor.prototype.isReady = function () {
        return this.ready;
    };
    ApplicationExecutor.prototype.isEnabled = function () {
        return this.enabled;
    };
    ApplicationExecutor.prototype.setReady = function (value) {
        this.ready = value;
    };
    ApplicationExecutor.prototype.setEnabled = function (value) {
        this.enabled = value;
    };
    ApplicationExecutor.prototype.callWhenPrepared = function (fn, finish) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.enabled || typeof fn !== "function") {
                            return [2 /*return*/];
                        }
                        if (!(this.ready && this.enabled)) return [3 /*break*/, 4];
                        if (!this.pendingExecutePair.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.executeQueue()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.executePair({
                            fn: fn,
                            finish: finish,
                        })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        this.pendingExecutePair.push({
                            fn: fn,
                            finish: finish,
                        });
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ApplicationExecutor.prototype.forceExecute = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setReady(true);
                this.executeQueue();
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], ApplicationExecutor.prototype, "observableService", void 0);
    ApplicationExecutor = __decorate([
        (0, inversify_1.injectable)()
    ], ApplicationExecutor);
    return ApplicationExecutor;
}());
exports.ApplicationExecutor = ApplicationExecutor;
